import React from 'react';
import LazyLoad from 'react-lazyload';
import './style.scss';

const GroupCategoriesPlatform = [
  {
    name: 'Quản trị doanh nghiệp',
    image: '/assets/img/payment.png',
    slug: '/nen-tang-so?cate=quan-tri-doanh-nghiep',
  },
  {
    name: 'Nghiệp vụ cụ thể',
    image: '/assets/img/governance.png',
    slug: '/nen-tang-so?cate=nghiep-vu-cu-the',
  },
  {
    name: 'Lĩnh vực đặc thù',
    image: '/assets/img/accountant.png',
    slug: '/nen-tang-so?cate=an-toan-an-ninh-mang',
  },
  {
    name: 'An ninh mạng',
    image: '/assets/img/security.png',
    slug: '/nen-tang-so?cate=smes-theo-nganh-linh-vuc',
  },
];

function GroupPlatform() {
  return (
    <div className='container'>
      <div className='sidebar-widget'>
        <div className='widget-header position-relative mb-30'>
          <h5 className='widget-title mb-30 text-uppercase color1 font-weight-ultra'>
            NHÓM NỀN TẢNG CHUYỂN ĐỔI SỐ
          </h5>
          <div className='letter-background'>N</div>
        </div>
        <div className='post-module-1 row'>
          {GroupCategoriesPlatform.map(({ image, name, slug }, index) => (
            <div className='col' key={index}>
              <div className='post-thumb position-relative '>
                <LazyLoad height={250}>
                  <div
                    className='thumb-overlay border-radius-5 position-relative image-platform'
                    style={{
                      backgroundImage: `url(${image})`,
                    }}
                  >
                    <a className='img-link' href={slug} />
                    <div className='post-content-overlay'>
                      {/* <div className='entry-meta meta-0 font-small mb-10'>
                        <a href='category.html'>
                          <span className='post-cat background2 color-white'>
                            Travel
                          </span>
                        </a>
                      </div> */}
                      <h6 className='post-title'>
                        <a className='color-white' href={slug}>
                          {name}
                        </a>
                      </h6>
                      {/* <div className='entry-meta meta-1 font-small color-grey mt-10 pr-5 pl-5'>
                        <span className='post-on'>02 Jan</span>
                        <span className='hit-count has-dot'>23k Views</span>
                        <a className='float-right' href='#'>
                          <i className='ti-heart'></i>
                        </a>
                      </div> */}
                    </div>
                  </div>
                </LazyLoad>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GroupPlatform;
